export enum PractitionerTypes {
  "Internal_Medicine" = "Internal Medicine",
  "Family_Medicine" = "Family Medicine",
  "Gastroenterology" = "Gastroenterology",
  "Pulmonology" = "Pulmonology",
}

export enum PersonalityTypes {
  "Clinical_Data_Driven" = "Clinical Data Driven",
  "Skeptical" = "Skeptical",
  "Story_Telling" = "Story-Telling",
  "Agreeable" = "Agreeable",
  "Busy" = "Busy",
  "To_The_Point" = "To-The-Point",
}

// rep, manager, admin, trainer
export const userRoles = {
  Admin: "ADMIN",
  Manager: "MANAGER",
  Trainer: "TRAINER",
  AccountSpecialist: "ACCOUNT_SPECIALIST",
  SalesRep: "SALES_REP"
};

export const userRoleLabels = {
  Admin: "Admin",
  Manager: "Manager",
  Trainer: "Trainer",
  AccountSpecialist: "Account Specialist",
};

export const certificationStatus = {
  Pass: {
    bgColor: "#14AE5C1A",
    textColor: "#14AE5C",
    label: "Pass",
  },
  Fail: {
    bgColor: "#FF00001A",
    textColor: "#FA3A1A",
    label: "Failed",
  },
  IN_PROGRESS: {
    bgColor: "#FFBA533B",
    textColor: "#9F7230",
    label: "In Progress",
  },
  InReview: {
    bgColor: "#FFBA533B",
    textColor: "#9F7230",
    label: "In Review",
  },
  NotStarted: {
    bgColor: "#9C9C9C1A",
    textColor: "#808080",
    label: "Not Started",
  },
};

export enum ObjectionLevels {
  "L" = "L",
  "M" = "M",
  "H" = "H",
}

export const ObjectionLevelTitles = {
  L: "Low",
  M: "Medium",
  H: "High",
};

export const ObjectionLevelConfig = {
  L: {
    title: "Low",
    color: "#15803D",
    backgroundColor: "#F0FDF4",
  },
  M: {
    title: "Medium",
    color: "#854D0E",
    backgroundColor: "#FEFCE8",
  },
  H: {
    title: "High",
    color: "#DC2626",
    backgroundColor: "#FEE2E2",
  },
};

export const PerformancePercentage = {
  Low: 50,
  Medium: 70,
  High: 90,
};

export const BasicDetails = {
  balanced: "Balanced",
  actionable: "Actionable",
  specific: "Specific",
  impact: "Impact",
  continuity: "Continuity",
  supportive: "Supportive",
};

export const LoadingItemTypes = {
  Tip: "tip",
  Testimonial: "testimonial",
} as const;

export const defaultMetricColor = {
  low: {
    progressBg: "#FFEBEB",
    progress: "#FA7D7D",
    text: "#FA7D7D",
  },
}

export const manualCertificationStatusInfo = {
  label: "Manual",
  backgroundColor: "#E7EBF7",
  textColor: "#1E46AB",
};

export const DEFAULT_LABELS: Record<string, { singular: string; plural: string } | string> = {
  defaultPrimer: "Hi, this is a recorded certification. I would like you to respond to a series of questions. Record your answer when you’re ready to respond. Are you ready to begin?",
  question: {
    singular: "Question",
    plural: "Questions"
  },
  certification: {
    singular: "Certification",
    plural: "Certifications"
  },
  attempt: {
    singular: "Attempt",
    plural: "Attempts"
  },
  session: {
    singular: "Certification",
    plural: "Certifications"
  },
  status: {
    singular: "Status",
    plural: "Statuses"
  },
  certificationName: {
    singular: "Certification",
    plural: "Certifications"
  },
  certificationProductName: "PraxisCertify",
  salesAidDocument: "Sales Aid Panel Document",
  certificationAccountSpecialistScreenSubtext: "Complete required certifications to maintain compliance.",
  certificationManagerAdminScreenSubtext: "Review your team's certification progress.",
  attemptsReviewedText: "will be reviewed to evaluate your performance."
}

export const DEFAULT_ROUTE_NAMES = {
  certificationRoute: "certifications",
}

// Routes that render without a session. Sending one of these to /login is
// destructive rather than merely redundant: it clears storage and signs the
// Cognito user out, which on /saml/callback races the token exchange and wipes
// the tokens it just wrote, and on /reset-password drops the cognitoUser that
// confirmPassword needs.
export const PUBLIC_ROUTES = [
  "/login",
  "/forgot-password",
  "/reset-password",
  "/saml/callback",
];

// Routes whose own flow establishes the session. A cookie restore must not run
// on them: it would race the flow, and whichever of the two lands last writes
// the session and the in-memory token, so a slow restore of the *previous*
// user can replace the login that just succeeded.
export const SESSION_ESTABLISHING_ROUTES = ["/saml/callback"];

export const isPublicRoute = (pathname: string = window.location.pathname) =>
  PUBLIC_ROUTES.includes(pathname);

export const establishesOwnSession = (pathname: string = window.location.pathname) =>
  SESSION_ESTABLISHING_ROUTES.includes(pathname);

export const MENU_LABELS = {
  certifications: "PraxisCertify",
  dashboard: "Dashboard",
  myProfile: "My Profile",
  team: "Team",
  engagementReport: "Engagement Report",
  tools: "Tools",
  praxisPlay: "PraxisPlay",
  admin: "Admin",
  support: "Support",
  getInTouch: "Get In Touch",
  faqs: "FAQs",
  tutorials: "Tutorials",
  badgeCenter: "Badge Center",
};

export const DEFAULT_NOTIFICATION_CATEGORIES = [
  { name: "All", value: "all" },
  { name: "Certifications", value: "Certifications" },
  { name: "Badge Center", value: "BadgeCenter" },
  { name: "PraxisPlay", value: "PraxisPlay" },
  { name: "Team", value: "Team" },
];

export const MENU_NAMES = {
  myProfile: "my-profile",
  tutorials: "tutorials",
};

export const GAME_MODE_TOOLTIP = "Game Mode will provide a Praxis Score and affect your Avg. Praxis Score.";
export const PRACTICE_MODE_TOOLTIP = "Practice Mode will not affect your Avg. Praxis Score.";